var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7232 8.70777L13.0562 15.7066C12.4609 16.3315 11.4291 15.8941 11.4291 14.9984V10.9991H6.03205C5.50424 10.9991 5.07962 10.5533 5.07962 9.99923V5.99989C5.07962 5.44582 5.50424 5.00006 6.03205 5.00006H11.4291V1.00072C11.4291 0.109201 12.457 -0.332392 13.0562 0.292504L19.7232 7.29134C20.0923 7.68294 20.0923 8.31617 19.7232 8.70777ZM7.61943 15.4983V13.8319C7.61943 13.557 7.40513 13.332 7.14321 13.332H3.80971C3.1073 13.332 2.53981 12.7363 2.53981 11.9989V4.00022C2.53981 3.26284 3.1073 2.66711 3.80971 2.66711H7.14321C7.40513 2.66711 7.61943 2.44215 7.61943 2.16719V0.500803C7.61943 0.225849 7.40513 0.000886044 7.14321 0.000886044H3.80971C1.70643 0.000886044 0 1.79226 0 4.00022V11.9989C0 14.2069 1.70643 15.9982 3.80971 15.9982H7.14321C7.40513 15.9982 7.61943 15.7733 7.61943 15.4983Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.c2b1bd32.svg";
export { ForwardRef as ReactComponent };